/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ContextType } from '../models';
import { Permission } from '../models';
import { ServerConfig } from '../models';
import { SetupAllForeignSchemasRequest } from '../models';
/**
 * ServerConfigApi - axios parameter creator
 * @export
 */
export const ServerConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigAllClientContentVersionsGet: async (server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/allClientContentVersions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigAllPermissionPrefixesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/allPermissionPrefixes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigAllPermissionsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/allPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigAllServersGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/allServers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigBringOnlinePost: async (server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/bringOnline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [foreignServer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigCheckForeignSchemaPost: async (foreignServer?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/checkForeignSchema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (foreignServer !== undefined) {
                localVarQueryParameter['foreignServer'] = foreignServer;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [environmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigDeployLatestOnibiApiGet: async (environmentName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/DeployLatestOnibiApi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (environmentName !== undefined) {
                localVarQueryParameter['environmentName'] = environmentName;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigGetClientContentVersionGet: async (server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/getClientContentVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigGetClientMinVersionGet: async (server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/getClientMinVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigPermissionTableByServerGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/permissionTableByServer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigServerEnvironmentPost: async (body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/serverEnvironment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigServerEnvironmentPut: async (body?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/serverEnvironment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [contentVersionHash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigSetClientContentVersionPost: async (server?: string, contentVersionHash?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/setClientContentVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (contentVersionHash !== undefined) {
                localVarQueryParameter['contentVersionHash'] = contentVersionHash;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [clientMinVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigSetClientMinVersionPost: async (server?: string, clientMinVersion?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/setClientMinVersion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (clientMinVersion !== undefined) {
                localVarQueryParameter['ClientMinVersion'] = clientMinVersion;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetupAllForeignSchemasRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigSetupAllForeignSchemasPost: async (body?: SetupAllForeignSchemasRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/setupAllForeignSchemas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [remoteHost] 
         * @param {string} [remotePassword] 
         * @param {string} [localSchema] 
         * @param {string} [remotePort] 
         * @param {string} [remoteDbname] 
         * @param {string} [remoteSchema] 
         * @param {string} [localUser] 
         * @param {string} [remoteUser] 
         * @param {ContextType} [contextType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigSetupForeignSchemaPost: async (remoteHost?: string, remotePassword?: string, localSchema?: string, remotePort?: string, remoteDbname?: string, remoteSchema?: string, localUser?: string, remoteUser?: string, contextType?: ContextType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/setupForeignSchema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (remoteHost !== undefined) {
                localVarQueryParameter['remoteHost'] = remoteHost;
            }

            if (remotePassword !== undefined) {
                localVarQueryParameter['remotePassword'] = remotePassword;
            }

            if (localSchema !== undefined) {
                localVarQueryParameter['localSchema'] = localSchema;
            }

            if (remotePort !== undefined) {
                localVarQueryParameter['remotePort'] = remotePort;
            }

            if (remoteDbname !== undefined) {
                localVarQueryParameter['remoteDbname'] = remoteDbname;
            }

            if (remoteSchema !== undefined) {
                localVarQueryParameter['remoteSchema'] = remoteSchema;
            }

            if (localUser !== undefined) {
                localVarQueryParameter['localUser'] = localUser;
            }

            if (remoteUser !== undefined) {
                localVarQueryParameter['remoteUser'] = remoteUser;
            }

            if (contextType !== undefined) {
                localVarQueryParameter['contextType'] = contextType;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [foreignServer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServerConfigUpdateForeignSchemaPost: async (foreignServer?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServerConfig/updateForeignSchema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            if (foreignServer !== undefined) {
                localVarQueryParameter['foreignServer'] = foreignServer;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServerConfigApi - functional programming interface
 * @export
 */
export const ServerConfigApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllClientContentVersionsGet(server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<string>>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigAllClientContentVersionsGet(server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllPermissionPrefixesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<Permission>>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigAllPermissionPrefixesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllPermissionsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<Permission>>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigAllPermissionsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllServersGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<{ [key: string]: any; }>>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigAllServersGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigBringOnlinePost(server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigBringOnlinePost(server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [foreignServer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigCheckForeignSchemaPost(foreignServer?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigCheckForeignSchemaPost(foreignServer, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [environmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigDeployLatestOnibiApiGet(environmentName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigDeployLatestOnibiApiGet(environmentName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigGetClientContentVersionGet(server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigGetClientContentVersionGet(server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigGetClientMinVersionGet(server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<string>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigGetClientMinVersionGet(server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigPermissionTableByServerGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Array<ServerConfig>>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigPermissionTableByServerGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigServerEnvironmentPost(body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigServerEnvironmentPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigServerEnvironmentPut(body?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigServerEnvironmentPut(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [contentVersionHash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetClientContentVersionPost(server?: string, contentVersionHash?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigSetClientContentVersionPost(server, contentVersionHash, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [clientMinVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetClientMinVersionPost(server?: string, clientMinVersion?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigSetClientMinVersionPost(server, clientMinVersion, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {SetupAllForeignSchemasRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetupAllForeignSchemasPost(body?: SetupAllForeignSchemasRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigSetupAllForeignSchemasPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [remoteHost] 
         * @param {string} [remotePassword] 
         * @param {string} [localSchema] 
         * @param {string} [remotePort] 
         * @param {string} [remoteDbname] 
         * @param {string} [remoteSchema] 
         * @param {string} [localUser] 
         * @param {string} [remoteUser] 
         * @param {ContextType} [contextType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetupForeignSchemaPost(remoteHost?: string, remotePassword?: string, localSchema?: string, remotePort?: string, remoteDbname?: string, remoteSchema?: string, localUser?: string, remoteUser?: string, contextType?: ContextType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigSetupForeignSchemaPost(remoteHost, remotePassword, localSchema, remotePort, remoteDbname, remoteSchema, localUser, remoteUser, contextType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [foreignServer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigUpdateForeignSchemaPost(foreignServer?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await ServerConfigApiAxiosParamCreator(configuration).apiServerConfigUpdateForeignSchemaPost(foreignServer, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ServerConfigApi - factory interface
 * @export
 */
export const ServerConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllClientContentVersionsGet(server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Array<string>>> {
            return ServerConfigApiFp(configuration).apiServerConfigAllClientContentVersionsGet(server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllPermissionPrefixesGet(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<Permission>>> {
            return ServerConfigApiFp(configuration).apiServerConfigAllPermissionPrefixesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllPermissionsGet(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<Permission>>> {
            return ServerConfigApiFp(configuration).apiServerConfigAllPermissionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigAllServersGet(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<{ [key: string]: any; }>>> {
            return ServerConfigApiFp(configuration).apiServerConfigAllServersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigBringOnlinePost(server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigBringOnlinePost(server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [foreignServer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigCheckForeignSchemaPost(foreignServer?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigCheckForeignSchemaPost(foreignServer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [environmentName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigDeployLatestOnibiApiGet(environmentName?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigDeployLatestOnibiApiGet(environmentName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigGetClientContentVersionGet(server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return ServerConfigApiFp(configuration).apiServerConfigGetClientContentVersionGet(server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigGetClientMinVersionGet(server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<string>> {
            return ServerConfigApiFp(configuration).apiServerConfigGetClientMinVersionGet(server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigPermissionTableByServerGet(options?: AxiosRequestConfig): Promise<AxiosResponse<Array<ServerConfig>>> {
            return ServerConfigApiFp(configuration).apiServerConfigPermissionTableByServerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigServerEnvironmentPost(body?: any, options?: AxiosRequestConfig): Promise<AxiosResponse<{ [key: string]: any; }>> {
            return ServerConfigApiFp(configuration).apiServerConfigServerEnvironmentPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigServerEnvironmentPut(body?: any, options?: AxiosRequestConfig): Promise<AxiosResponse<{ [key: string]: any; }>> {
            return ServerConfigApiFp(configuration).apiServerConfigServerEnvironmentPut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [contentVersionHash] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetClientContentVersionPost(server?: string, contentVersionHash?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigSetClientContentVersionPost(server, contentVersionHash, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {string} [clientMinVersion] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetClientMinVersionPost(server?: string, clientMinVersion?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigSetClientMinVersionPost(server, clientMinVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetupAllForeignSchemasRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetupAllForeignSchemasPost(body?: SetupAllForeignSchemasRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigSetupAllForeignSchemasPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [remoteHost] 
         * @param {string} [remotePassword] 
         * @param {string} [localSchema] 
         * @param {string} [remotePort] 
         * @param {string} [remoteDbname] 
         * @param {string} [remoteSchema] 
         * @param {string} [localUser] 
         * @param {string} [remoteUser] 
         * @param {ContextType} [contextType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigSetupForeignSchemaPost(remoteHost?: string, remotePassword?: string, localSchema?: string, remotePort?: string, remoteDbname?: string, remoteSchema?: string, localUser?: string, remoteUser?: string, contextType?: ContextType, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigSetupForeignSchemaPost(remoteHost, remotePassword, localSchema, remotePort, remoteDbname, remoteSchema, localUser, remoteUser, contextType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [foreignServer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServerConfigUpdateForeignSchemaPost(foreignServer?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return ServerConfigApiFp(configuration).apiServerConfigUpdateForeignSchemaPost(foreignServer, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServerConfigApi - object-oriented interface
 * @export
 * @class ServerConfigApi
 * @extends {BaseAPI}
 */
export class ServerConfigApi extends BaseAPI {
    /**
     * 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigAllClientContentVersionsGet(server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<string>>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigAllClientContentVersionsGet(server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigAllPermissionPrefixesGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<Permission>>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigAllPermissionPrefixesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigAllPermissionsGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<Permission>>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigAllPermissionsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigAllServersGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<{ [key: string]: any; }>>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigAllServersGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigBringOnlinePost(server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigBringOnlinePost(server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [foreignServer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigCheckForeignSchemaPost(foreignServer?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigCheckForeignSchemaPost(foreignServer, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [environmentName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigDeployLatestOnibiApiGet(environmentName?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigDeployLatestOnibiApiGet(environmentName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigGetClientContentVersionGet(server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigGetClientContentVersionGet(server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigGetClientMinVersionGet(server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<string>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigGetClientMinVersionGet(server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigPermissionTableByServerGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<Array<ServerConfig>>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigPermissionTableByServerGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {any} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigServerEnvironmentPost(body?: any, options?: AxiosRequestConfig) : Promise<AxiosResponse<{ [key: string]: any; }>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigServerEnvironmentPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {any} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigServerEnvironmentPut(body?: any, options?: AxiosRequestConfig) : Promise<AxiosResponse<{ [key: string]: any; }>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigServerEnvironmentPut(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [contentVersionHash] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigSetClientContentVersionPost(server?: string, contentVersionHash?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigSetClientContentVersionPost(server, contentVersionHash, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {string} [clientMinVersion] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigSetClientMinVersionPost(server?: string, clientMinVersion?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigSetClientMinVersionPost(server, clientMinVersion, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {SetupAllForeignSchemasRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigSetupAllForeignSchemasPost(body?: SetupAllForeignSchemasRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigSetupAllForeignSchemasPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [remoteHost] 
     * @param {string} [remotePassword] 
     * @param {string} [localSchema] 
     * @param {string} [remotePort] 
     * @param {string} [remoteDbname] 
     * @param {string} [remoteSchema] 
     * @param {string} [localUser] 
     * @param {string} [remoteUser] 
     * @param {ContextType} [contextType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigSetupForeignSchemaPost(remoteHost?: string, remotePassword?: string, localSchema?: string, remotePort?: string, remoteDbname?: string, remoteSchema?: string, localUser?: string, remoteUser?: string, contextType?: ContextType, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigSetupForeignSchemaPost(remoteHost, remotePassword, localSchema, remotePort, remoteDbname, remoteSchema, localUser, remoteUser, contextType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [foreignServer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServerConfigApi
     */
    public async apiServerConfigUpdateForeignSchemaPost(foreignServer?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return ServerConfigApiFp(this.configuration).apiServerConfigUpdateForeignSchemaPost(foreignServer, options).then((request) => request(this.axios, this.basePath));
    }
}
